import { Scene, Color } from 'three';
import Grid from './Grid.js';
import Sky from './Sky.js';

export default class BackgroundScene {
    constructor() {
        // Singleton pattern
        if (BackgroundScene.instance) {
            return BackgroundScene.instance;
        }
        BackgroundScene.instance = this;

        // Create scene
        this.scene = new Scene();
        this.scene.background = new Color(0x000000);

        // Initialize components
        this.initComponents();
    }

    // Static method to get the instance
    static getInstance() {
        if (!BackgroundScene.instance) {
            BackgroundScene.instance = new BackgroundScene();
        }
        return BackgroundScene.instance;
    }

    initComponents() {
        // Add components to the scene
        this.grid = new Grid();
        this.sky = new Sky();
    }

    resize() {
        // Update components
        if (this.grid && this.grid.resize) this.grid.resize();
        if (this.sky && this.sky.resize) this.sky.resize();
    }

    update(delta, movementSpeed) {
        if (this.grid) this.grid.update(delta, movementSpeed);
        if (this.sky) this.sky.update(delta);
    }

    getScene() {
        return this.scene;
    }
}
